import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { StyledCard, StyledNormalText } from "../../globalComponents/styles";
import { StyledBoldText } from "../../globalComponents/styles";
import { Box, Divider } from "@material-ui/core";
import { themes } from "../../globalAssets/theme";
import companyLogo from "../../images/companyLogo2.jpeg";
import { ToolBar, HistoryBar } from "../Invoice/SingleInvoice";
import { useParams, useRouteMatch } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllReceipt, fetchSingleReceipt, selectReceipts } from "./slice";
import moment from "moment";
import { Statistic } from "antd";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Services from "../../../services";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const initialBillInfo = [
  {
    title: "bill To",
    value: "",
  },
  {
    title: "Payment Date",
    value: "",
  },
  {
    title: "Payment Method",
    value: "",
  },
];

export const ReceiptDetail = (props) => {
  const { singleReceipt } = useSelector(selectReceipts);
  const [billInfo, setBillInfo] = useState(initialBillInfo);
  const { id } = useParams();
  const dispatcher = useDispatch();
  const history = useHistory();
  const { url, path } = useRouteMatch();

  const [feedbackProps, setFeedbackProps] = useState({
    open: false,
    type: "",
    message: "",
  });
  const [deleteModalProps, setDeleteModalProps] = useState({
    visible: false,
    name: "",
    id: null,
    loading: false,
  });

  useEffect(() => {
    dispatcher(fetchSingleReceipt({ id }));
  }, []);

  useEffect(() => {
    const billInfo = [
      {
        title: "bill To",
        value: singleReceipt.billTo,
      },
      {
        title: "Payment Date",
        value: moment(singleReceipt.created_at).format("Do MMM, YYYY"),
      },
      {
        title: "Payment Method",
        value: singleReceipt.paymentMethod,
      },
    ];
    setBillInfo(billInfo);
  }, [singleReceipt]);

  const billInfoList = billInfo.map((item, index) => {
    return <SingleDetail data={item} key={index} />;
  });

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleRefresh = () => window.location.reload();
  const downloadPDF = () => {
    const input = document.getElementById("receipt-to-print");

    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4"); // Portrait, millimeters, A4

      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`invoice-${singleReceipt?.invoice_number}.pdf`);
    });
  };

  const handleReceiptDelete = async () => {
    console.log("deleting");
    try {
      setDeleteModalProps((prevState) => ({ ...prevState, loading: true }));
      await Services.deleteReceipt({
        id: id,
      });
      // await dispatcher(fetchAllReceipt({ page, size: rowsPerPage }));
      setFeedbackProps({
        type: "success",
        message: `${deleteModalProps.name} has been deleted`,
        open: true,
      });
      setDeleteModalProps((prevState) => ({
        ...prevState,
        loading: false,
        visible: false,
      }));
      history.push(`/receipts`);
      // window.location.reload();
    } catch (error) {
      console.log(error);
      setDeleteModalProps((prevState) => ({ ...prevState, loading: false }));
      setFeedbackProps({
        type: "error",
        message: `Please try again`,
        open: true,
      });
    }
  };

  return (
    <>
      <ToolBar
        hidePaymentButton
        //       onClick={handleToolClick}
        downloadPDF={downloadPDF}
        handleRefresh={handleRefresh}
        handlePrint={handlePrint}
        handleDelete={handleReceiptDelete}
      />
      <HistoryBar />
      <StyledCard pb={6} mt={3} px={4} py={2}>
        <Box p={3} ref={componentRef} id="receipt-to-print">
          <Box mb={6} display="flex" alignItems="flex-end">
            <StyledImage src={companyLogo} alt="logo" />
            <StyledBoldText variant="h5">First Marine</StyledBoldText>
          </Box>
          <StyledBoldText gutterBottom={true} variant="h4">
            Receipt
          </StyledBoldText>
          <Box display="flex">
            <StyledBoldText variant="subtitle2">Receipt Number:</StyledBoldText>
            <Box ml={3}>
              <StyledBoldText variant="subtitle2">
                {singleReceipt.receiptNumber}
              </StyledBoldText>
            </Box>
          </Box>
          <StyledReciptBody>
            <Box display="flex">
              <Box
                px={6}
                py={4}
                flexBasis="50%"
                style={{ backgroundColor: "#F3F6FC" }}
              >
                {billInfoList}
              </Box>
              <Box
                px={6}
                py={4}
                flexBasis="50%"
                style={{
                  backgroundColor: themes.primaryColor,
                  color: themes.white,
                }}
              >
                <StyledBoldText
                  style={{ color: themes.white }}
                  gutterBottom={true}
                  align="center"
                  variant="body1"
                >
                  Payment Amount
                </StyledBoldText>

                <Statistic
                  valueStyle={{
                    color: themes.white,
                    fontSize: "3vw",
                    fontWeight: "bolder",
                    textAlign: "center",
                  }}
                  value={singleReceipt.paymentAmount}
                  prefix="₦"
                  precision={2}
                />
                {/*  <StyledBoldText
                style={{ color: themes.white }}
                align="center"
                variant="h3"
              >
                ${singleReceipt.paymentAmount}
              </StyledBoldText> */}
              </Box>
            </Box>
            <Box mt={6} py={4} px={6} style={{ backgroundColor: "#F3F6FC" }}>
              <Box display="flex" justifyContent="space-between">
                <SingleDetail
                  data={{
                    title: "invoice number",
                    value: singleReceipt.invoiceNumber,
                  }}
                />
                <SingleDetail
                  isamount
                  data={{
                    title: "Invoice Amount",
                    value: singleReceipt.invoiceAmount,
                  }}
                />
              </Box>
              {/* <Box px={6} mt={4} mb={2}>
                  <Divider/>
              </Box>
              <Box display='flex' justifyContent='space-between'>
                  <SingleDetail data={{title: 'invoice number', value: 'INV/0000001'}}/>
                  <SingleDetail data={{title: 'Invoice Amount', value: 'N 300,0001'}}/>
              </Box> */}
            </Box>
          </StyledReciptBody>
        </Box>
      </StyledCard>
    </>
  );
};

const SingleDetail = (props) => {
  return (
    <Box
      mt={2}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <StyledBoldText
        style={{ textTransform: "capitalize" }}
        variant="subtitle2"
      >
        {props.data.title}:
      </StyledBoldText>
      <Box ml={4}>
        {props.isamount ? (
          <Statistic value={props.data.value} prefix="₦" precision={2} />
        ) : (
          <StyledNormalText
            style={{ textTransform: "capitalize" }}
            variant="body2"
            align="left"
          >
            {props.data.value}
          </StyledNormalText>
        )}
      </Box>
    </Box>
  );
};
const StyledReciptBody = styled(Box)`
  width: 90%;
  margin: 0 auto;
  margin-top: 24px;
`;
const StyledImage = styled.img`
  width: 10%;
`;
